import { render, staticRenderFns } from "./EditException.vue?vue&type=template&id=52873644&scoped=true"
import script from "./EditException.vue?vue&type=script&lang=js"
export * from "./EditException.vue?vue&type=script&lang=js"
import style0 from "./EditException.vue?vue&type=style&index=0&id=52873644&prod&lang=scss"
import style1 from "./EditException.vue?vue&type=style&index=1&id=52873644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52873644",
  null
  
)

export default component.exports